/*
* Styling   https://datatables.net/manual/styling/classes
* */
// https://www.mobil.nrw.dev.local/information-service/qualitaetsmonitor-nrw/filter/2021/2/db_regio-eurobahn-hessische_landesbahn/nvr-nwl/re/re13-re17/2
class DataTablesController {
    constructor() {
        this.filterForm = document.querySelector('.qm-filter-bar');
        this.develop = true;
        this.datatablesContainer = document.querySelector('.datatables-container');

        this.copyElement = document.querySelector('input.copyURL');
        this.copyContainer = document.querySelector('.filter-copy');

        this.activeQuarters = {
            0: true,
            1: true,
            2: true,
            3: true
        };

        // Generated Fluid Endpoints
        if (window.location.href.search(/filter/g) > -1) {
            this.baseURL = window.location.href.split('filter/');
            this.endpoint = this.datatablesContainer.dataset.endpointAjaxurlfilter;
            this.externalLink = true;
            document.querySelector('.qm-filter').style.display = 'none';
            document.querySelector('.qm-buttons').style.display = 'none';
            document.querySelector('.filter-message').style.display = 'block';
            this.filterHintOnCopyLink();
        } else {
            this.baseURL = window.location.href.split('.html');
            this.endpoint = this.datatablesContainer.dataset.endpointAjaxlist;
            this.externalLink = false;
        }

        this.endpointFilter = this.datatablesContainer.dataset.endpointFiltershow;
        this.modifiedData = this.datatablesContainer.dataset.endpointAjaxlistfilter;

        // options
        this.tableOptions = {
            "element": $('#monitoring-table'),
            "endpointStatic": "http://localhost:3000/data/data.json",
            "endpoint": this.endpoint,
            "endpointFilter": this.endpointFilter,
            "modifiedData": this.modifiedData,
            "dataTable": null
        };
    }

    initDataTablesController = () => {
        // Init datatables
        this.initDatatables(); // Init datatables with datatables-ajax method+
        if(!this.externalLink) this.initFilter();
        this.initClickEventLoadmore();
    }

    /**********/

    /*
    * @desc         Init datatables with datatables-ajax method
    * @endpoint     this.tableOptions.endpoint
    * */
    initDatatables = () => {
        let self = this;
        $(document).ready( () => {
            if (this.externalLink) {
                this.tableOptions.dataTable = this.tableOptions.element.DataTable({
                    "processing": true,
                    responsive: {
                        breakpoints: [
                            {name: 'bigdesktop', width: Infinity},
                            {name: 'meddesktop', width: 1480},
                            {name: 'smalldesktop', width: 1280},
                            {name: 'medium', width: 1188},
                            {name: 'tabletl', width: 1024},
                            {name: 'btwtabllandp', width: 848},
                            {name: 'tabletp', width: 768},
                            {name: 'mobilel', width: 480},
                            {name: 'mobilep', width: 320}
                        ]
                    },
                    "bPaginate": true,
                    "pageLength": 10,
                    "order": [[ 10, "desc" ]], // order by ranking
                    "serverSide": false, // if true, paging has to be performed by the server
                    "searching": true,
                    "search": {
                        "smart": true,
                        "caseInsensitive": true,
                    },
                    "language": {
                        "decimal": ",",
                        "thousands": ".",
                        "info": "Ergebnisse _START_ bis _END_ von _TOTAL_ Einträgen",
                        "infoEmpty": "Keine Einträge",
                        "infoPostFix": "",
                        "infoFiltered": "(gefiltert aus insgesamt _MAX_ Einträgen)",
                        "loadingRecords": "Bitte warten Sie - Daten werden geladen ...",
                        "lengthMenu": "Anzeigen von _MENU_ Einträgen",
                        "paginate": {
                            "first": "Erste",
                            "last": "Letzte",
                            "next": "Nächste",
                            "previous": "Zurück"
                        },
                        "processing": "Verarbeitung läuft ...",
                        "search": "Suche:",
                        "searchPlaceholder": "Suchbegriff",
                        "zeroRecords": "Keine Daten! Bitte ändern Sie Ihren Suchbegriff. <br><br>" +
                            "<i>Ihre Filter-Einstellung werden berücksichtigt und erst aktiv, nachdem Sie die Filter angewendet haben." +
                            "</i> <br><button type=\"button\" class=\"btn btn-primary btn-rounded btn-modal lightbox\" ata-open-modal=\"#cp-qm-faq\" title=\"Qualitätsmonitor: FAQs\" style=\"margin: 0 auto;\" data-toggle=\"modal\" data-target=\"#exampleModal\">\n" +
                            "FAQ ansehen</button><br><br> Versuchen Sie z. B.: <br> <i>S-Bahn</i> <br> <i>DB Regio</i> <br> <i>VRR</i> <br> <i>RRX</i>",
                        "emptyTable": "Keine Daten vorhanden",
                        "aria": {
                            "sortAscending":  ": aktivieren, um Spalte aufsteigend zu sortieren",
                            "sortDescending": ": aktivieren, um Spalte absteigend zu sortieren"
                        },
                        //only works for built-in buttons, not for custom buttons
                        "buttons": {
                            "create": "Neu",
                            "edit": "Ändern",
                            "remove": "Löschen",
                            "copy": "Kopieren",
                            "csv": "CSV-Datei",
                            "excel": "Excel-Tabelle",
                            "pdf": "PDF-Dokument",
                            "print": "Drucken",
                            "colvis": "Spalten Auswahl",
                            "collection": "Auswahl",
                            "upload": "Datei auswählen...."
                        }
                    },
                    "ajax": {
                        "url": this.tableOptions.endpoint,
                        'dataSrc': function (d) {
                            return d.routes.data
                        },
                        'error': function (data) {
                            console.log('failure', data);
                        },
                        "type": "POST"
                    },
                    "columnDefs": [
                        {
                            "targets": [ 0, 2, 3, 4, 5, 6, 7 ],
                            "visible": false, // hidden columns
                            "searchable": false
                        },
                        {
                            "targets": [ 1 ],
                            "visible": false, // hidden columns
                            "searchable": true
                        },
                        {
                            "targets": [ 16 ],
                            "visible": false, // hidden columns
                            "searchable": true
                        },
                        {
                            "targets": [ 9 ],
                            "visible": true, // hidden columns
                            "searchable": false
                        },
                        // Add classes to td
                        { "className": "id", "targets": [0] },
                        { "className": "evu", "targets": [1] },
                        { "className": "producttype", "targets": [2] },
                        { "className": "client", "targets": [3] },
                        { "className": "fullname", "targets": [4] },
                        { "className": "subnet", "targets": [5] },
                        { "className": "runtime", "targets": [6] },
                        { "className": "line_stations", "targets": [7] },
                        { "className": "ranking", "targets": [8] },
                        { "className": "line", "targets": [9] },
                        { "type": "num", "className": "overall_ranking", "targets": [10] },
                        { "className": "complexity", "targets": [11] },
                        { "className": "passengers", "targets": [12] },
                        { "type": "num", "className": "punctuality", "targets": [13] },
                        { "type": "num", "className": "reliability", "targets": [14] },
                        { "type": "num", "className": "train_formation", "targets": [15]},
                        { "className": "search-line", "targets": [16] },
                    ],
                    // Add ajax response to cells
                    "columns": [
                        { "data": "_id" },
                        { "data": "_evu" },
                        { "data": "_producttype" },
                        { "data": "_client" },
                        { "data": "_fullname" },
                        { "data": "_subnet" },
                        { "data": "_runtime" },
                        { "data": "_line_stations" },
                        { "data": "ranking", defaultContent: ''},
                        {
                            "data": "line",
                            render: function(data, type, row) {
                                return `
                                <div class="qm-tooltip hide">
                                    Detailansicht der Linie
                                </div>

                                <div class="icon-info icon-info--line"></div>

                                <div class="qm-info-box qm-info-box--line hide">
                                    <div class="icon-close"></div>
                                    <div class="qm-info-box--line__line">
                                        <span>${row.line}</span>
                                    </div>
                                    <div class="qm-info-box--line__name">
                                        <span>${row.line}:</span>
                                        <span>${row._fullname}</span>
                                    </div>
                                    <div class="qm-info-box--line__subnet">
                                        <span>Teilnetz:</span>
                                        <span>${row._subnet}</span>
                                    </div>
                                    <div class="qm-info-box--line__running-time">
                                        <span>Laufzeit:</span>
                                        <span>${row._runtime}</span>
                                    </div>
                                    <div class="qm-info-box--line__evu">
                                        <span>EVU:</span>
                                        <span>${row._evutooltip}</span>
                                    </div>
                                    <div class="qm-info-box--line__route">
                                        <span>Linienweg:</span>
                                        <span>${row._line_stations}</span>
                                    </div>
                                </div>
                                <span class="ranking-in-line">${row.ranking}</span>
                                <span>${row.line}</span>
                                <span style="opacity: .5;">${this.replaceNationwideWithNRWInString(row._evu)}</span>`;
                            }.bind(this)
                        },
                        {
                            "data": "overall_ranking",
                            render: function(data, type, row) {
                                let settings = {
                                    name: 'overall_ranking',
                                    average: this.averageQuarterValue(row.overall_ranking) > 100 ? 100 : this.averageQuarterValue(row.overall_ranking),
                                    quarters: row.overall_ranking.quarters,
                                    year: row.overall_ranking.year,
                                    threshold: {
                                        danger_below: 90,
                                        warning_below: 95
                                    },
                                    activeQuarter: this.activeQuarters
                                }

                                let result = new RenderController().barchart(settings);
                                if (type === 'sort') {
                                    result = Number(this.averageQuarterValue(row.overall_ranking));
                                }

                                return result
                            }.bind(this)
                        },
                        {
                            "data": "complexity.year",
                            render: function(data, type, row) {
                                let value = row.complexity.quarters,
                                    valueSum = 0, count = 0, status, average;

                                for (let i = 0; i < value.length; i++) {
                                    if (value[i] > 0) {
                                        count = count + 1;
                                        valueSum = valueSum + value[i];
                                    }
                                }

                                if (count > 0 && valueSum > 0) {
                                    average = valueSum / count;
                                }
                                switch (average) {
                                    case 0:
                                        status = '';
                                        break;
                                    case 1:
                                        status = 'simple';
                                        break;
                                    case 2:
                                        status = 'normal';
                                        break;
                                    case 3:
                                        status = 'complex';
                                        break;
                                }

                                return `
                                <div style="display: none;">${average}</div>
                                <div class="graph graph--complexity ${status}">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                `;

                            }.bind(this)
                        },
                        {
                            "data": "passengers.year",
                            render: function(data, type, row) {
                                let value = row.passengers.quarters,
                                    valueSum = 0, count = 0, status, average;

                                for (let i = 0; i < value.length; i++) {
                                    if (value[i] > 0) {
                                        count = count + 1;
                                        valueSum = valueSum + value[i];
                                    }
                                }

                                if (count > 0 && valueSum > 0) {
                                    average = valueSum / count;
                                }
                                switch (average) {
                                    case 0:
                                        status = '';
                                        break;
                                    case 1:
                                        status = 'empty';
                                        break;
                                    case 2:
                                        status = 'normal';
                                        break;
                                    case 3:
                                        status = 'full';
                                        break;
                                    case 4:
                                        status = 'extreme';
                                        break;
                                }

                                return `
                                <div style="display: none;">${average}</div>
                                <div class="qm-tooltip hide">
                                    Detailansicht der Fahrgäste
                                </div>

                                <div class="graph graph--passengers ${status}">
                                    <svg width="14" height="30" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.614 1.2a3.723 3.723 0 00-3.72 3.72c0 2.05 1.669 3.719 3.72 3.719a3.723 3.723 0 003.719-3.72c0-2.05-1.669-3.719-3.72-3.719m0 8.639a4.925 4.925 0 01-4.919-4.92A4.925 4.925 0 016.614 0a4.925 4.925 0 014.919 4.92 4.925 4.925 0 01-4.92 4.919M2.463 29.815h1.2V18.454h-1.2zM9.572 29.814h1.2v-11.36h-1.2z"/>
                                        <path d="M3.063 24.505C1.373 24.505 0 23.11 0 21.395v-6.321c0-2.62 2.06-4.451 5.012-4.451h1.602v1.2H5.012c-1.898 0-3.812 1.005-3.812 3.25v6.323c0 1.052.836 1.909 1.863 1.909v1.2zM10.172 24.505v-1.2c1.04 0 1.855-.839 1.855-1.91v-6.321c0-2.246-1.914-3.251-3.811-3.251H6.614v-1.2h1.602c2.95 0 5.011 1.83 5.011 4.45v6.323c0 1.714-1.37 3.109-3.055 3.109M6.014 29.815h1.2v-5.91h-1.2z"/>
                                    </svg>
                                    <svg width="14" height="30" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.614 1.2a3.723 3.723 0 00-3.72 3.72c0 2.05 1.669 3.719 3.72 3.719a3.723 3.723 0 003.719-3.72c0-2.05-1.669-3.719-3.72-3.719m0 8.639a4.925 4.925 0 01-4.919-4.92A4.925 4.925 0 016.614 0a4.925 4.925 0 014.919 4.92 4.925 4.925 0 01-4.92 4.919M2.463 29.815h1.2V18.454h-1.2zM9.572 29.814h1.2v-11.36h-1.2z"/>
                                        <path d="M3.063 24.505C1.373 24.505 0 23.11 0 21.395v-6.321c0-2.62 2.06-4.451 5.012-4.451h1.602v1.2H5.012c-1.898 0-3.812 1.005-3.812 3.25v6.323c0 1.052.836 1.909 1.863 1.909v1.2zM10.172 24.505v-1.2c1.04 0 1.855-.839 1.855-1.91v-6.321c0-2.246-1.914-3.251-3.811-3.251H6.614v-1.2h1.602c2.95 0 5.011 1.83 5.011 4.45v6.323c0 1.714-1.37 3.109-3.055 3.109M6.014 29.815h1.2v-5.91h-1.2z"/>
                                    </svg>
                                    <svg width="14" height="30" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.614 1.2a3.723 3.723 0 00-3.72 3.72c0 2.05 1.669 3.719 3.72 3.719a3.723 3.723 0 003.719-3.72c0-2.05-1.669-3.719-3.72-3.719m0 8.639a4.925 4.925 0 01-4.919-4.92A4.925 4.925 0 016.614 0a4.925 4.925 0 014.919 4.92 4.925 4.925 0 01-4.92 4.919M2.463 29.815h1.2V18.454h-1.2zM9.572 29.814h1.2v-11.36h-1.2z"/>
                                        <path d="M3.063 24.505C1.373 24.505 0 23.11 0 21.395v-6.321c0-2.62 2.06-4.451 5.012-4.451h1.602v1.2H5.012c-1.898 0-3.812 1.005-3.812 3.25v6.323c0 1.052.836 1.909 1.863 1.909v1.2zM10.172 24.505v-1.2c1.04 0 1.855-.839 1.855-1.91v-6.321c0-2.246-1.914-3.251-3.811-3.251H6.614v-1.2h1.602c2.95 0 5.011 1.83 5.011 4.45v6.323c0 1.714-1.37 3.109-3.055 3.109M6.014 29.815h1.2v-5.91h-1.2z"/>
                                    </svg>
                                    <svg width="14" height="30" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.614 1.2a3.723 3.723 0 00-3.72 3.72c0 2.05 1.669 3.719 3.72 3.719a3.723 3.723 0 003.719-3.72c0-2.05-1.669-3.719-3.72-3.719m0 8.639a4.925 4.925 0 01-4.919-4.92A4.925 4.925 0 016.614 0a4.925 4.925 0 014.919 4.92 4.925 4.925 0 01-4.92 4.919M2.463 29.815h1.2V18.454h-1.2zM9.572 29.814h1.2v-11.36h-1.2z"/>
                                        <path d="M3.063 24.505C1.373 24.505 0 23.11 0 21.395v-6.321c0-2.62 2.06-4.451 5.012-4.451h1.602v1.2H5.012c-1.898 0-3.812 1.005-3.812 3.25v6.323c0 1.052.836 1.909 1.863 1.909v1.2zM10.172 24.505v-1.2c1.04 0 1.855-.839 1.855-1.91v-6.321c0-2.246-1.914-3.251-3.811-3.251H6.614v-1.2h1.602c2.95 0 5.011 1.83 5.011 4.45v6.323c0 1.714-1.37 3.109-3.055 3.109M6.014 29.815h1.2v-5.91h-1.2z"/>
                                    </svg>
                                </div>
                                `;

                            }.bind(this)
                        },
                        {
                            "data": "punctuality.year",
                            render: function(data, type, row) {
                                let settings = {
                                    name: 'punctuality',
                                    average: this.averageQuarterValue(row.punctuality),
                                    quarters: row.punctuality.quarters,
                                    year: row.punctuality.year,
                                    threshold: {
                                        danger_below: 80,
                                        warning_below: 90
                                    },
                                    activeQuarter: this.activeQuarters
                                }

                                let result = new RenderController().barchart(settings);
                                if (type === 'sort') {
                                    result = Number(this.averageQuarterValue(row.punctuality));
                                }

                                return result
                            }.bind(this)
                        },
                        {
                            "data": "reliability.year",
                            render: function(data, type, row) {
                                let settings = {
                                    name: 'reliability',
                                    average: this.averageQuarterValue(row.reliability),
                                    quarters: row.reliability.quarters,
                                    year: row.reliability.year,
                                    threshold: {
                                        danger_below: 98.5,
                                        warning_below: 99.2
                                    },
                                    activeQuarter: this.activeQuarters
                                }

                                let result = new RenderController().barchart(settings);
                                if (type === 'sort') {
                                    result = Number(this.averageQuarterValue(row.reliability));
                                }

                                return result
                            }.bind(this)
                        },
                        {
                            "data": "train_formation.year",
                            render: function(data, type, row) {
                                let settings = {
                                    name: 'train_formation',
                                    average: this.averageQuarterValue(row.train_formation),
                                    quarters: row.train_formation.quarters,
                                    year: row.train_formation.year,
                                    threshold: {
                                        danger_below: 98.5,
                                        warning_below: 99.3
                                    },
                                    activeQuarter: this.activeQuarters
                                }

                                let result = new RenderController().barchart(settings);
                                if (type === 'sort') {
                                    result = Number(this.averageQuarterValue(row.train_formation));
                                }

                                return result
                            }.bind(this)
                        },
                        { "data": "line" },
                    ],
                    createdRow: function(row, data, dataIndex, cells) {
                        $(row).addClass(data.line.toLowerCase());
                        $(row).attr('data-evu', data._evu);
                        $(row).attr('data-producttype', data._producttype);
                        $(row).attr('data-client', data._client);
                        $(row).attr('data-fullname', data._fullname);
                        $(row).attr('data-subnet', data._subnet);
                        $(row).attr('data-runtime', data._runtime);
                        $(row).attr('data-line_stations', data._line_stations);
                        $(row).attr('data-line', data.line);
                        $(row).attr('data-total-ranking-year', data.overall_ranking.year);
                        $(row).attr('data-total-ranking-value', data.overall_ranking.value);
                        $(row).attr('data-complexity-year', data.complexity.year);
                        $(row).attr('data-complexity-value', data.complexity.value);
                        $(row).attr('data-complexity-quarter', data.complexity.quarters);
                        $(row).attr('data-passengers-year', data.passengers.year);
                        $(row).attr('data-passengers-value', data.passengers.value);
                        $(row).attr('data-punctuality-year', data.punctuality.year);
                        $(row).attr('data-punctuality-value', data.punctuality.value);
                        $(row).attr('data-reliability-year', data.reliability.year);
                        $(row).attr('data-reliability-value', data.reliability.value);
                        $(row).attr('data-train_formation-year', data.train_formation.year);
                        $(row).attr('data-train_formation-value', data.train_formation.value);
                    },
                    "drawCallback": function() {
                        let target = document.querySelector('p.results')
                        // let heading = target.parentNode.querySelector('h1');

                        // Ranking
                        let api = this.api(),
                            cols = api.columns(10).data()[0], // contains an object
                            arr = [];

                        cols.forEach((el) => {
                            arr.push(self.averageQuarterValue(el)) // calc average of quarters inside the given object
                        })

                        let sorted = arr.slice().sort(function(a, b){ return b - a }),
                            ranks = arr.slice().map(function(v){ return sorted.indexOf(v) + 1 });

                        this.api().rows().every(function () {
                            let data = this.data();
                            data.ranking = ranks[arr.indexOf(self.averageQuarterValue(data.overall_ranking))];
                            // heading.innerHTML = `Ihre Ergebnisse für alle Quartale im Jahr ${data.overall_ranking.year}.`
                        });

                        this.api().rows().invalidate();
                        // Ranking end

                        // Plugin: ./vendor/dataTables.pageLoadMore.min.js in bundle.js
                        $('#datatables-add-more').toggle( this.api().page.hasMore() );

                        // Init popup and tooltip function
                        new infoboxFunctions();
                    },
                });
            } else {
                this.tableOptions.dataTable = this.tableOptions.element.DataTable({
                    "processing": true,
                    responsive: {
                        breakpoints: [
                            {name: 'bigdesktop', width: Infinity},
                            {name: 'meddesktop', width: 1480},
                            {name: 'smalldesktop', width: 1280},
                            {name: 'medium', width: 1188},
                            {name: 'tabletl', width: 1024},
                            {name: 'btwtabllandp', width: 848},
                            {name: 'tabletp', width: 768},
                            {name: 'mobilel', width: 480},
                            {name: 'mobilep', width: 320}
                        ]
                    },
                    "bPaginate": true,
                    "pageLength": 10,
                    "order": [[ 10, "desc" ]], // order by ranking
                    "serverSide": false, // if true, paging has to be performed by the server
                    "searching": true,
                    "search": {
                        "smart": true,
                        "caseInsensitive": true,
                    },
                    "language": {
                        "decimal": ",",
                        "thousands": ".",
                        "info": "Ergebnisse _START_ bis _END_ von _TOTAL_ Einträgen",
                        "infoEmpty": "Keine Einträge",
                        "infoPostFix": "",
                        "infoFiltered": "(gefiltert aus insgesamt _MAX_ Einträgen)",
                        "loadingRecords": "Bitte warten Sie - Daten werden geladen ...",
                        "lengthMenu": "Anzeigen von _MENU_ Einträgen",
                        "paginate": {
                            "first": "Erste",
                            "last": "Letzte",
                            "next": "Nächste",
                            "previous": "Zurück"
                        },
                        "processing": "Verarbeitung läuft ...",
                        "search": "Suche:",
                        "searchPlaceholder": "Suchbegriff",
                        "zeroRecords": "Keine Daten! Bitte ändern Sie Ihren Suchbegriff. <br><br>" +
                            "<i>Ihre Filter-Einstellung werden berücksichtigt und erst aktiv, nachdem Sie die Filter angewendet haben." +
                            "</i> <br><button type=\"button\" class=\"btn btn-rounded btn-modal\" title=\"Qualitätsmonitor: FAQs\" style=\"margin: 0 auto;\" data-toggle=\"modal\" data-target=\"#exampleModal\">\n" +
                            "FAQ ansehen</button><br><br> Versuchen Sie z. B.: <br> <i>S-Bahn</i> <br> <i>DB Regio</i> <br> <i>VRR</i> <br> <i>RRX</i>",
                        "emptyTable": "Keine Daten vorhanden",
                        "aria": {
                            "sortAscending":  ": aktivieren, um Spalte aufsteigend zu sortieren",
                            "sortDescending": ": aktivieren, um Spalte absteigend zu sortieren"
                        },
                        //only works for built-in buttons, not for custom buttons
                        "buttons": {
                            "create": "Neu",
                            "edit": "Ändern",
                            "remove": "Löschen",
                            "copy": "Kopieren",
                            "csv": "CSV-Datei",
                            "excel": "Excel-Tabelle",
                            "pdf": "PDF-Dokument",
                            "print": "Drucken",
                            "colvis": "Spalten Auswahl",
                            "collection": "Auswahl",
                            "upload": "Datei auswählen...."
                        }
                    },
                    "ajax": {
                        "url": this.tableOptions.endpoint,
                        "type": "POST"
                    },
                    "columnDefs": [
                        {
                            "targets": [ 0, 2, 3, 4, 5, 6, 7 ],
                            "visible": false, // hidden columns
                            "searchable": false
                        },
                        {
                            "targets": [ 1 ],
                            "visible": false, // hidden columns
                            "searchable": true
                        },
                        {
                            "targets": [ 16 ],
                            "visible": false, // hidden columns
                            "searchable": true
                        },
                        {
                            "targets": [ 9 ],
                            "visible": true, // hidden columns
                            "searchable": false
                        },
                        // Add classes to td
                        { "className": "id", "targets": [0] },
                        { "className": "evu", "targets": [1] },
                        { "className": "producttype", "targets": [2] },
                        { "className": "client", "targets": [3] },
                        { "className": "fullname", "targets": [4] },
                        { "className": "subnet", "targets": [5] },
                        { "className": "runtime", "targets": [6] },
                        { "className": "line_stations", "targets": [7] },
                        { "className": "ranking", "targets": [8] },
                        { "className": "line", "targets": [9] },
                        { "type": "num", "className": "overall_ranking", "targets": [10] },
                        { "className": "complexity", "targets": [11] },
                        { "className": "passengers", "targets": [12] },
                        { "type": "num", "className": "punctuality", "targets": [13] },
                        { "type": "num", "className": "reliability", "targets": [14] },
                        { "type": "num", "className": "train_formation", "targets": [15]},
                        { "className": "search-line", "targets": [16] },
                    ],
                    // Add ajax response to cells
                    "columns": [
                        { "data": "_id" },
                        { "data": "_evu" },
                        { "data": "_producttype" },
                        { "data": "_client" },
                        { "data": "_fullname" },
                        { "data": "_subnet" },
                        { "data": "_runtime" },
                        { "data": "_line_stations" },
                        { "data": "ranking", defaultContent: ''},
                        {
                            "data": "line",
                            render: function(data, type, row) {
                                return `
                                <div class="qm-tooltip hide">
                                    Detailansicht der Linie
                                </div>

                                <div class="icon-info icon-info--line"></div>

                                <div class="qm-info-box qm-info-box--line hide">
                                    <div class="icon-close"></div>
                                    <div class="qm-info-box--line__line">
                                        <span>${row.line}</span>
                                    </div>
                                    <div class="qm-info-box--line__name">
                                        <span>${row.line}:</span>
                                        <span>${row._fullname}</span>
                                    </div>
                                    <div class="qm-info-box--line__subnet">
                                        <span>Teilnetz:</span>
                                        <span>${row._subnet}</span>
                                    </div>
                                    <div class="qm-info-box--line__running-time">
                                        <span>Laufzeit:</span>
                                        <span>${row._runtime}</span>
                                    </div>
                                    <div class="qm-info-box--line__evu">
                                        <span>EVU:</span>
                                        <span>${row._evutooltip}</span>
                                    </div>
                                    <div class="qm-info-box--line__route">
                                        <span>Linienweg:</span>
                                        <span>${row._line_stations}</span>
                                    </div>
                                </div>
                                <span class="ranking-in-line">${row.ranking}</span>
                                <span>${row.line}</span>
                                <span style="opacity: .5;">${this.replaceNationwideWithNRWInString(row._evu)}</span>`;
                            }.bind(this)
                        },
                        {
                            "data": "overall_ranking",
                            render: function(data, type, row) {
                                let settings = {
                                    name: 'overall_ranking',
                                    average: isNaN(this.averageQuarterValue(row.overall_ranking)) ? 'n.v.' : this.averageQuarterValue(row.overall_ranking) > 100 ? 100 : this.averageQuarterValue(row.overall_ranking),
                                    quarters: row.overall_ranking.quarters,
                                    year: row.overall_ranking.year,
                                    threshold: {
                                        danger_below: 90,
                                        warning_below: 95
                                    },
                                    activeQuarters: this.activeQuarters
                                }

                                let result = new RenderController().barchart(settings);
                                if (type === 'sort') {
                                    result = Number(this.averageQuarterValue(row.overall_ranking));
                                }

                                return result
                            }.bind(this)
                        },
                        {
                            "data": "complexity.year",
                            render: function(data, type, row) {
                                let value = row.complexity.quarters,
                                    valueSum = 0, count = 0, status, average;

                                for (let i = 0; i < value.length; i++) {
                                    if (value[i] > 0) {
                                        count = count + 1;
                                        valueSum = valueSum + value[i];
                                    }
                                }

                                if (count > 0 && valueSum > 0) {
                                    average = valueSum / count;
                                }
                                switch (average) {
                                    case 0:
                                        status = '';
                                        break;
                                    case 1:
                                        status = 'simple';
                                        break;
                                    case 2:
                                        status = 'normal';
                                        break;
                                    case 3:
                                        status = 'complex';
                                        break;
                                }

                                return `
                                <div style="display: none;">${average}</div>
                                <div class="graph graph--complexity ${status}">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                `;

                            }.bind(this)
                        },
                        {
                            "data": "passengers.year",
                            render: function(data, type, row) {
                                let value = row.passengers.quarters,
                                    valueSum = 0, count = 0, status, average;

                                for (let i = 0; i < value.length; i++) {
                                    if (value[i] > 0) {
                                        count = count + 1;
                                        valueSum = valueSum + value[i];
                                    }
                                }

                                if (count > 0 && valueSum > 0) {
                                    average = valueSum / count;
                                }
                                switch (average) {
                                    case 0:
                                        status = '';
                                        break;
                                    case 1:
                                        status = 'empty';
                                        break;
                                    case 2:
                                        status = 'normal';
                                        break;
                                    case 3:
                                        status = 'full';
                                        break;
                                    case 4:
                                        status = 'extreme';
                                        break;
                                }

                                return `
                                <div style="display: none;">${average}</div>
                                <div class="qm-tooltip hide">
                                    Detailansicht der Fahrgäste
                                </div>

                                <div class="graph graph--passengers ${status}">
                                    <svg width="14" height="30" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.614 1.2a3.723 3.723 0 00-3.72 3.72c0 2.05 1.669 3.719 3.72 3.719a3.723 3.723 0 003.719-3.72c0-2.05-1.669-3.719-3.72-3.719m0 8.639a4.925 4.925 0 01-4.919-4.92A4.925 4.925 0 016.614 0a4.925 4.925 0 014.919 4.92 4.925 4.925 0 01-4.92 4.919M2.463 29.815h1.2V18.454h-1.2zM9.572 29.814h1.2v-11.36h-1.2z"/>
                                        <path d="M3.063 24.505C1.373 24.505 0 23.11 0 21.395v-6.321c0-2.62 2.06-4.451 5.012-4.451h1.602v1.2H5.012c-1.898 0-3.812 1.005-3.812 3.25v6.323c0 1.052.836 1.909 1.863 1.909v1.2zM10.172 24.505v-1.2c1.04 0 1.855-.839 1.855-1.91v-6.321c0-2.246-1.914-3.251-3.811-3.251H6.614v-1.2h1.602c2.95 0 5.011 1.83 5.011 4.45v6.323c0 1.714-1.37 3.109-3.055 3.109M6.014 29.815h1.2v-5.91h-1.2z"/>
                                    </svg>
                                    <svg width="14" height="30" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.614 1.2a3.723 3.723 0 00-3.72 3.72c0 2.05 1.669 3.719 3.72 3.719a3.723 3.723 0 003.719-3.72c0-2.05-1.669-3.719-3.72-3.719m0 8.639a4.925 4.925 0 01-4.919-4.92A4.925 4.925 0 016.614 0a4.925 4.925 0 014.919 4.92 4.925 4.925 0 01-4.92 4.919M2.463 29.815h1.2V18.454h-1.2zM9.572 29.814h1.2v-11.36h-1.2z"/>
                                        <path d="M3.063 24.505C1.373 24.505 0 23.11 0 21.395v-6.321c0-2.62 2.06-4.451 5.012-4.451h1.602v1.2H5.012c-1.898 0-3.812 1.005-3.812 3.25v6.323c0 1.052.836 1.909 1.863 1.909v1.2zM10.172 24.505v-1.2c1.04 0 1.855-.839 1.855-1.91v-6.321c0-2.246-1.914-3.251-3.811-3.251H6.614v-1.2h1.602c2.95 0 5.011 1.83 5.011 4.45v6.323c0 1.714-1.37 3.109-3.055 3.109M6.014 29.815h1.2v-5.91h-1.2z"/>
                                    </svg>
                                    <svg width="14" height="30" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.614 1.2a3.723 3.723 0 00-3.72 3.72c0 2.05 1.669 3.719 3.72 3.719a3.723 3.723 0 003.719-3.72c0-2.05-1.669-3.719-3.72-3.719m0 8.639a4.925 4.925 0 01-4.919-4.92A4.925 4.925 0 016.614 0a4.925 4.925 0 014.919 4.92 4.925 4.925 0 01-4.92 4.919M2.463 29.815h1.2V18.454h-1.2zM9.572 29.814h1.2v-11.36h-1.2z"/>
                                        <path d="M3.063 24.505C1.373 24.505 0 23.11 0 21.395v-6.321c0-2.62 2.06-4.451 5.012-4.451h1.602v1.2H5.012c-1.898 0-3.812 1.005-3.812 3.25v6.323c0 1.052.836 1.909 1.863 1.909v1.2zM10.172 24.505v-1.2c1.04 0 1.855-.839 1.855-1.91v-6.321c0-2.246-1.914-3.251-3.811-3.251H6.614v-1.2h1.602c2.95 0 5.011 1.83 5.011 4.45v6.323c0 1.714-1.37 3.109-3.055 3.109M6.014 29.815h1.2v-5.91h-1.2z"/>
                                    </svg>
                                    <svg width="14" height="30" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.614 1.2a3.723 3.723 0 00-3.72 3.72c0 2.05 1.669 3.719 3.72 3.719a3.723 3.723 0 003.719-3.72c0-2.05-1.669-3.719-3.72-3.719m0 8.639a4.925 4.925 0 01-4.919-4.92A4.925 4.925 0 016.614 0a4.925 4.925 0 014.919 4.92 4.925 4.925 0 01-4.92 4.919M2.463 29.815h1.2V18.454h-1.2zM9.572 29.814h1.2v-11.36h-1.2z"/>
                                        <path d="M3.063 24.505C1.373 24.505 0 23.11 0 21.395v-6.321c0-2.62 2.06-4.451 5.012-4.451h1.602v1.2H5.012c-1.898 0-3.812 1.005-3.812 3.25v6.323c0 1.052.836 1.909 1.863 1.909v1.2zM10.172 24.505v-1.2c1.04 0 1.855-.839 1.855-1.91v-6.321c0-2.246-1.914-3.251-3.811-3.251H6.614v-1.2h1.602c2.95 0 5.011 1.83 5.011 4.45v6.323c0 1.714-1.37 3.109-3.055 3.109M6.014 29.815h1.2v-5.91h-1.2z"/>
                                    </svg>
                                </div>
                                `;

                            }.bind(this)
                        },
                        {
                            "data": "punctuality.year",
                            render: function(data, type, row) {
                                let settings = {
                                    name: 'punctuality',
                                    average: isNaN(this.averageQuarterValue(row.punctuality)) ? 'n.v.' : this.averageQuarterValue(row.punctuality) > 100 ? 100 : this.averageQuarterValue(row.punctuality),
                                    quarters: row.punctuality.quarters,
                                    year: row.punctuality.year,
                                    threshold: {
                                        danger_below: 80,
                                        warning_below: 90
                                    },
                                    activeQuarters: this.activeQuarters
                                }

                                let result = new RenderController().barchart(settings);
                                if (type === 'sort') {
                                    result = Number(this.averageQuarterValue(row.punctuality));
                                }

                                return result
                            }.bind(this)
                        },
                        {
                            "data": "reliability.year",
                            render: function(data, type, row) {
                                let settings = {
                                    name: 'reliability',
                                    average: isNaN(this.averageQuarterValue(row.reliability)) ? 'n.v.' : this.averageQuarterValue(row.reliability) > 100 ? 100 : this.averageQuarterValue(row.reliability),
                                    quarters: row.reliability.quarters,
                                    year: row.reliability.year,
                                    threshold: {
                                        danger_below: 98.5,
                                        warning_below: 99.2
                                    },
                                    activeQuarters: this.activeQuarters
                                }

                                let result = new RenderController().barchart(settings);
                                if (type === 'sort') {
                                    result = Number(this.averageQuarterValue(row.reliability));
                                }

                                return result
                            }.bind(this)
                        },
                        {
                            "data": "train_formation.year",
                            render: function(data, type, row) {
                                let settings = {
                                    name: 'train_formation',
                                    average: isNaN(this.averageQuarterValue(row.train_formation)) ? 'n.v.' : this.averageQuarterValue(row.train_formation) > 100 ? 100 : this.averageQuarterValue(row.train_formation),
                                    quarters: row.train_formation.quarters,
                                    year: row.train_formation.year,
                                    threshold: {
                                        danger_below: 98.5,
                                        warning_below: 99.3
                                    },
                                    activeQuarters: this.activeQuarters
                                }

                                let result = new RenderController().barchart(settings);
                                if (type === 'sort') {
                                    result = Number(this.averageQuarterValue(row.train_formation));
                                }

                                return result
                            }.bind(this)
                        },
                        { "data": "line" },
                    ],
                    createdRow: function(row, data, dataIndex, cells) {
                        $(row).addClass(data.line.toLowerCase());
                        $(row).attr('data-evu', data._evu);
                        $(row).attr('data-producttype', data._producttype);
                        $(row).attr('data-client', data._client);
                        $(row).attr('data-fullname', data._fullname);
                        $(row).attr('data-subnet', data._subnet);
                        $(row).attr('data-runtime', data._runtime);
                        $(row).attr('data-line_stations', data._line_stations);
                        $(row).attr('data-line', data.line);
                        $(row).attr('data-total-ranking-year', data.overall_ranking.year);
                        $(row).attr('data-total-ranking-value', data.overall_ranking.value);
                        $(row).attr('data-complexity-year', data.complexity.year);
                        $(row).attr('data-complexity-value', data.complexity.value);
                        $(row).attr('data-complexity-quarter', data.complexity.quarters);
                        $(row).attr('data-passengers-year', data.passengers.year);
                        $(row).attr('data-passengers-value', data.passengers.value);
                        $(row).attr('data-punctuality-year', data.punctuality.year);
                        $(row).attr('data-punctuality-value', data.punctuality.value);
                        $(row).attr('data-reliability-year', data.reliability.year);
                        $(row).attr('data-reliability-value', data.reliability.value);
                        $(row).attr('data-train_formation-year', data.train_formation.year);
                        $(row).attr('data-train_formation-value', data.train_formation.value);
                    },
                    "drawCallback": function() {
                        let target = document.querySelector('p.results')
                        // let heading = target.parentNode.querySelector('h1');
                        // Ranking
                        let api = this.api(),
                            cols = api.columns(10).data()[0], // contains an object
                            arr = [];

                        cols.forEach((el) => {
                            arr.push(self.averageQuarterValue(el)) // calc average of quarters inside the given object
                        })

                        let sorted = arr.slice().sort(function(a, b){ return b - a }),
                            ranks = arr.slice().map(function(v){ return sorted.indexOf(v) + 1 });

                        this.api().rows().every(function () {
                            let data = this.data();
                            data.ranking = ranks[arr.indexOf(self.averageQuarterValue(data.overall_ranking))];
                            //heading.innerHTML = `Ihre Ergebnisse für alle Quartale im Jahr ${data.overall_ranking.year}.`
                        });

                        this.api().rows().invalidate();
                        // Ranking end

                        // Plugin: ./vendor/dataTables.pageLoadMore.min.js in bundle.js
                        $('#datatables-add-more').toggle( this.api().page.hasMore() );

                        // Init popup and tooltip function
                        new infoboxFunctions();
                    },
                });
            }

            // custom search
            $('#dt-custom-search').on( 'keyup click', () => {
                let searchValue = document.querySelector('#dt-custom-search').value,
                    regEx = /([A-Za-z]{1,2}\s{0,1}\d{1,}\w{0,1})/g

                if (searchValue.match(regEx)) {
                    searchValue = searchValue.replace(/\s/g,'');
                }

                this.tableOptions.dataTable.search(searchValue).draw();
            } );
        });
    };

    /*
    * @desc         Calculates the average of given quarters per year
    * @params       input {object} data to calculate with
    * @return       {float}
    */
    averageQuarterValue(input) {
        let sum = 0,
            length = 0;
        for ( let i = 0; i < input.quarters.length; i++ ) {
            if (parseFloat(input.quarters[i], 10) > 0) {
                sum += parseFloat(input.quarters[i], 10);
                length += 1;
            }
        }

        let average = sum / length * 100;
        return average.toFixed(1);
    }

    /**
     * @desc Replaces "NATIONWIDE" with "NRW"
     * @param evu
     * @returns {*}
     */
    replaceNationwideWithNRWInString = (evu) => {
        if (evu !== null && evu !== '') {
            return evu.replace('NATIONWIDE', 'NRW');
        }

        return evu;
    }

    filterProcess = (direction, event) => {
        let filterList = this.filterForm.querySelectorAll('.qm-filter__dropdown'),
            filterIndex,
            filterObject = {
                'year': "",
                'quarter': "",
                'evu': "",
                'region': "",
                'product_type': "",
                'lines': "",
                'complexity': ""
            };

        Array.from(filterList).forEach(function(dropdown) {
            let filter = dropdown.querySelectorAll('input');
            Array.from(filter).forEach(function(filter) {
                let name = filter.getAttribute('data-type');
                if (filter.checked && name in filterObject) {
                    filterObject[name] += filter.value + ',';
                }
            });
        });

        Object.keys(filterObject).forEach(function(key) {
            let value = filterObject[key];
            filterObject[key] = value.substring(0, value.length - 1);
        });

        if (event !== '' && !event.target.className.includes('sub-filter')) {
            if (this.filterForm.querySelector(`#filter-${event.target.name}`).nextElementSibling !== null) {
                this.filterForm.querySelector(`#filter-${event.target.name}`).nextElementSibling.classList.remove('disabled');
                filterIndex = this.filterForm.querySelector(`#filter-${event.target.name}`).getAttribute('data-index');
            }
        }

        filterIndex = (parseInt(filterIndex) + 1);
        new FilterActions().countActiveFilter(filterObject);
        let savedFilters = new FilterActions().saveFilterOnRequest(filterObject);
        new FilterActions().countActiveFilter(filterObject);

        // Copy Link function
        let url_string = 'filter/';
        for (let prop in filterObject) {
            url_string += ((filterObject[prop] !== '') ? filterObject[prop].toLowerCase().replaceAll(/\//g, '$').replaceAll(',', ';').replaceAll(' ', '_') + '/' : '0/').replace('s-bahn', 's_bahn');
        }

        this.copyContainer.style.display = 'flex';
        this.copyElement.value = this.baseURL[0] + ((this.baseURL[0].slice(-1) !== '/') ? '/' : '') + url_string;
        this.copyElement.addEventListener('click', () => {
            navigator.clipboard.writeText(this.copyElement.value);
        })

        this.ajaxFilterPost(filterObject, direction, filterIndex, savedFilters);
    }

    /*
    * @desc         Collects all filter options
    * @return       {object} all filter data to use to request
    * */
    initFilter = () => {
        let submitFormBtn = this.filterForm.querySelector('.qm-buttons .submit'); // submit button

        submitFormBtn.addEventListener('click', (event) => {
            event.preventDefault();
            this.filterProcess('table', '');
        });
    }

    /*
    * @desc         XMLHttpRequest filter data
    * @params       filter {object} contains all filters collected in filterObject @this.initFilter()
    * @params       method {string} is given the direction which function should be fired after success
    * @return       {object|json}
    * */
    ajaxFilterPost = (filter, method, filterIndex, savedFilters) => {
        $.ajax({
            url: this.tableOptions.endpointFilter,
            type: 'POST',
            dataType: "json",
            data: { tx_cpqualitymonitor_filtershow: {'filter': filter} },
            success: res => {
                if (method === 'table') {
                    $.ajax({
                        url: this.tableOptions.modifiedData,
                        type: 'POST',
                        dataType: "json",
                        data: { tx_cpqualitymonitor_ajaxlistfilter: {'filter': filter} },
                        success: (result) => {

                            let dropdowns = Array.from(document.querySelectorAll('.qm-filter__dropdown__content'));

                            dropdowns.forEach(dropdown => {
                                let countSelectedQuarters = () => {
                                    let selectedInputs = Array.from(dropdown.querySelectorAll('.main-filter.quarter'));
                                    let counter = 0;
                                    let atLeastOneChecked = false;

                                    selectedInputs.forEach(input => {
                                        if (input.classList.contains('available') && input.checked) {
                                            atLeastOneChecked = true;
                                        }
                                    })

                                    if (atLeastOneChecked) {
                                        selectedInputs.forEach(input => {
                                            this.activeQuarters[counter] = input.classList.contains('available') && input.checked;
                                            counter++;
                                        });
                                    }
                                };
                                countSelectedQuarters();
                            });

                            this.initFilterHint(filter);
                            this.initDatatablesAJAXReload(); // received data and reload tables
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.error(`${errorThrown}`);
                            console.error(`${textStatus}`);
                        }
                    });
                } else if (method === 'filter') {
                    new FilterActions().updateFilter(res, filterIndex, savedFilters); // reinit all filters
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                console.error(`${errorThrown}`);
                console.error(`${textStatus}`);
            }
        });
    }

    initFilterHint = filter => {
        if (!this.externalLink) {
            let target = document.querySelector('p.results'),
                dropdowns = Array.from(document.querySelectorAll('.qm-filter__dropdown__content')),
                original = new Array(),
                regionView,
                complexityView,
                quarterView,
                typeView;

            let heading = document.getElementById('intro-headline');

            let countElements = dropdown => {
                let inputs = Array.from(dropdown.querySelectorAll('input')),
                    count = 0,
                    name = '',
                    inputValues = new Array();

                inputs.forEach(input => {
                    if (input.classList.contains('available') && input.checked) {
                        let content = input.parentNode.querySelector('.text-content').innerHTML;
                        inputValues.push(content);
                        count++
                    }
                    name = input.getAttribute('data-type');
                });

                return { count, name, inputValues };
            }

            dropdowns.forEach(dropdown => {
                let res = countElements(dropdown)
                original[res.name] = { count: res.count, inputValues: res.inputValues};
            })

            if (original['region'].count === 1) {
                regionView = `die Region <strong>${original['region'].inputValues[0]}</strong>`
            } else if (original['region'].count === 2) {
                regionView = `die Regionen <strong>${original['region'].inputValues[0]}</strong> und <strong>${original['region'].inputValues[1]}</strong>`
            } else {
                regionView = `<strong>ganz NRW</strong>`
            }

            if (original['complexity'].count === 1) {
                complexityView = `<strong>${original['complexity'].inputValues[0].toLowerCase()}er</strong> Komplexität`
            } else if (original['product_type'].count === 2) {
                complexityView = `<strong>${original['complexity'].inputValues[0].toLowerCase()}er</strong> und <strong>${original['complexity'].inputValues[1].toLowerCase()}er</strong> Komplexität`
            } else {
                complexityView = `<strong>allen Komplexitätsniveaus</strong>`
            }

            if (original['product_type'].count === 1) {
                typeView = `Der berücksichtigte Produkttyp ist <strong>${original['product_type'].inputValues[0]}</strong>`
            } else if (original['product_type'].count === 2) {
                typeView = `Die berücksichtigten Produkttypen sind <strong>${original['product_type'].inputValues[0]}</strong> und <strong>${original['product_type'].inputValues[1]}</strong>`
            } else if (original['product_type'].inputValues[0] === undefined) {
                typeView = `Sie berücksichtigen <strong>alle Produkttypen</strong>`
            } else {
                typeView = `Die berücksichtigten Produkttypen sind <strong>${original['product_type'].inputValues[0]}</strong>, <strong>${original['product_type'].inputValues[1]}</strong> und <strong>${original['product_type'].inputValues[2]}</strong>`
            }

            if (original['quarter'].count === 1 ) {
                quarterView = `Quartal ${original['quarter'].inputValues[0]}`
            } else if (original['quarter'].count === 2 ) {
                quarterView = `Quartal ${original['quarter'].inputValues[0]} und ${original['quarter'].inputValues[1]}`
            } else if (original['quarter'].count === 3 ) {
                quarterView = `Quartal ${original['quarter'].inputValues[0]}, ${original['quarter'].inputValues[1]} und ${original['quarter'].inputValues[2]}`
            } else {
                quarterView = `alle Quartale`
            }

            heading.innerHTML = `Ihre Ergebnisse für ${quarterView} im Jahr ${original['year'].inputValues[0]}.`
            target.innerHTML = `
                Sie haben aktuell <strong>${(original['evu'].count > 0) ? original['evu'].count : 'alle'} EVU</strong> für ${regionView} ausgewählt.
                ${typeView} mit ${complexityView}.
                Es wird Ihnen die Betriebsqualität von <strong>${(original['lines'].count > 0) ? original['lines'].count : 'allen'} Linien</strong> angezeigt.
            `
        }
    }

    filterHintOnCopyLink = () => {
        if (this.externalLink) {
            let target = document.querySelector('p.results'),
                heading = target.parentNode.querySelector('h1'),
                regionView,
                complexityView,
                year,
                quarterView,
                evuView,
                linesCount,
                typeView;


            fetch(this.endpoint)
                .then(response => response.json())
                .then(data => {
                    data.filter.forEach(filter => {
                        switch (filter.target) {
                            case 'year':
                                year = filter.items[0].title

                                // add an offset of 1 to the lines count only for year 2024, to match data structure
                                linesCount = (filter.items[0].title === 2024) ? 1 : 0;
                                break;
                            case 'quarter':
                                quarterView = rewrite_quarter(filter.target, filter.items.length, filter.items)
                                break;
                            case 'region':
                                regionView = rewrite_region(filter.target, filter.items.length, filter.items)
                                break;
                            case 'evu':
                                evuView = filter.items.length
                                break;
                            case 'product_type':
                                typeView = rewrite_type(filter.target, filter.items.length, filter.items)
                                break;
                            case 'complexity':
                                complexityView = rewrite_complexity(filter.target, filter.items.length, filter.items)
                                break;
                            case 'lines':
                                linesCount += filter.items.filter(item => item.status === 'available').length;
                                break;
                            default:
                                // console.log(filter.target)
                                console.log()
                        }
                    })

                    heading.innerHTML = `Ihre Ergebnisse für ${quarterView} im Jahr ${year}.`
                    target.innerHTML = `
                        Sie haben aktuell <strong>${(evuView > 0) ? evuView : 'alle'} EVU</strong> für ${regionView} ausgewählt.
                        ${typeView} mit ${complexityView}.
                        Es wird Ihnen die Betriebsqualität von <strong>${(linesCount > 0) ? linesCount : 'allen'} Linien</strong> angezeigt.
                    `
                });

            function rewrite_quarter(title, count, items) {
                if (count === 1 ) {
                    quarterView = `Quartal ${items[0].title}`
                } else if (count === 2 ) {
                    quarterView = `Quartal ${items[0].title} und ${items[1].title}`
                } else if (count === 3 ) {
                    quarterView = `Quartal ${items[0].title}, ${items[1].title} und ${items[2].title}`
                } else {
                    quarterView = `alle Quartale`
                }
                return quarterView;
            }

            function rewrite_region(title, count, items) {
                if (count === 1) {
                    regionView = `die Region <strong>${items[0].title}</strong>`
                } else if (count === 2) {
                    regionView = `die Regionen <strong>${items[0].title}</strong> und <strong>${items[1].title}</strong>`
                } else {
                    regionView = `<strong>ganz NRW</strong>`
                }
                return regionView;
            }

            function rewrite_type(title, count, items) {
                if (count === 1) {
                    typeView = `Der berücksichtigte Produkttyp ist <strong>${items[0].title}</strong>`
                } else if (count === 2) {
                    typeView = `Die berücksichtigten Produkttypen sind <strong>${items[0].title}</strong> und <strong>${items[1].title}</strong>`
                } else if (items[0].title === undefined) {
                    typeView = `Sie berücksichtigen <strong>alle Produkttypen</strong>`
                } else {
                    typeView = `Die berücksichtigten Produkttypen sind <strong>${items[0].title}</strong>, <strong>${items[1].title}</strong> und <strong>${items[2].title}</strong>`
                }
                return typeView;
            }

            function rewrite_complexity(title, count, items) {
                if (count === 1) {
                    let item1 = (items[0].title === 1) ? 'einfach' : (items[0].title === 2) ? 'normal' : 'anspruchsvoll'
                    complexityView = `<strong>${item1.toLowerCase()}er</strong> Komplexität`
                } else if (count === 2) {
                    let item1 = (items[0].title === 1) ? 'einfach' : (items[0].title === 2) ? 'normal' : 'anspruchsvoll'
                    let item2 = (items[1].title === 1) ? 'einfach' : (items[1].title === 2) ? 'normal' : 'anspruchsvoll'
                    complexityView = `<strong>${item1.toLowerCase()}er</strong> und <strong>${item2.toLowerCase()}er</strong> Komplexität`
                } else {
                    complexityView = `<strong>allen Komplexitätsniveaus</strong>`
                }
                return complexityView;
            }
        }
    }

    /*
    * @desc         Reloads dataTables with new data
    * @params       data {object|json} contains all data received by the latest ajax request
    * */
    initDatatablesAJAXReload = ()  => {
        let dt = this.tableOptions.dataTable.ajax.url(this.modifiedData).load();
    }

    /*
    * @desc         Click event to load more data.
    *               This is loading data from the other pages
    * @Plugin       https://github.com/gyrocode/jquery-datatables-pageLoadMore
    * */
    initClickEventLoadmore = () => {
        $('#datatables-add-more').on('click', () => {
            this.tableOptions.dataTable.page.loadMore();
        });
    }
//
}
